export default __webpack_public_path__ + "static/media/Zara_Zamani_AHV_In_Moms_We_Trust.ab5ef710.jpg";